// extracted by mini-css-extract-plugin
module.exports = {"tools":"FilteredProductList-module__tools___3GgjV"};